import * as types from './types';
import Box from '../../../../helpers/request/box';

const BoxRequest = new Box();

export const resumeRequestData = ({ commit, rootState }) => {
  const boxId = rootState.route.params.boxId;

  const queryString = {
    params: {
      from: rootState.resume.dateFrom,
      to: rootState.resume.dateTo,
    },
  };

  BoxRequest.resume(boxId, queryString)
    .then(response => commit(types.RESUME_SET_DATA, response.data));
};

export const resumeResetState = ({ commit }) => {
  commit(types.RESUME_RESET_STATE);
};

export const resumeSetDateFrom = ({ commit }, dateFrom) => {
  commit(types.RESUME_SET_DATE_FROM, dateFrom);
};

export const resumeSetDateTo = ({ commit }, dateTo) => {
  commit(types.RESUME_SET_DATE_TO, dateTo);
};

export const resumeReloadCharts = ({ dispatch }) => {
  dispatch('resumeRequestData');
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/resume/actions.js
 **/